export enum ExpandableContentStatus {
  Collapsed = "collapsed",
  Collapsing = "collapsing",
  Expanded = "expanded",
  Expanding = "expanding"
}
